export function mergeConfiguration<T extends Object>(
  target: T,
  source: Partial<T>
): T {
  return Object.assign(target, source);
}
